<template>
  <div class="Overlay" @click.prevent="onClick"></div>
</template>

<script>
  import { menu, useMenu } from '@/store/menu'
  import { fastlinks, useFastlinks } from '@/store/fastlinks'

  export default {
    methods: {
      onClick() {
        // Menu
        const menuOpen = menu.value.isOpen
        if(menuOpen) useMenu.close()

        // FastLink
        const fastlinksOpen = fastlinks.value.isOpen
        if(fastlinksOpen) useFastlinks.close()
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Overlay.scss";
</style>
